var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bar-chart",style:({
    backgroundColor:
      this.chartData.series && this.chartData.series.length == 0
        ? '#F8F8F8'
        : '#fff',
  }),attrs:{"id":_vm.chartId}})
}
var staticRenderFns = []

export { render, staticRenderFns }